import React from "react"
import { Link } from "react-router-dom"
import { IconArrowUpRight, IconClock, IconMapPin } from "@tabler/icons-react"

type Props = {
  name: string
  address: string
  serviceTimes: string[]
  mapUrl: string
  pagePath?: string
}

const LandingLocationCard: React.FC<Props> = ({ name, address, serviceTimes, mapUrl, pagePath }) => {
  return (
    <article className="group relative flex h-full flex-col overflow-hidden rounded-2xl border border-[#ebebeb]/80 bg-white shadow-[0_8px_30px_-12px_rgba(0,43,122,0.1)] transition duration-300 hover:-translate-y-1 hover:border-[#9e7e43]/20 hover:shadow-[0_16px_40px_-16px_rgba(0,43,122,0.14)]">
      <div className="h-1 bg-gradient-to-r from-dc-primary-900 via-[#9e7e43] to-[#D6E5FF]" />

      <div className="flex flex-1 flex-col gap-5 p-6">
        <h3 className="font-outfit text-xl font-semibold tracking-tight text-[#0d0d0d]">{name}</h3>

        <div className="flex gap-2.5 font-dm-sans text-sm leading-6 text-[#5a5a5a]">
          <IconMapPin size={16} stroke={1.5} className="mt-0.5 shrink-0 text-[#9e7e43]" />
          <span>{address}</span>
        </div>

        <div className="flex flex-col gap-2.5">
          <p className="font-dm-sans text-xs font-semibold uppercase tracking-[0.14em] text-dc-primary-900">
            Service Times
          </p>
          <ul className="flex flex-col gap-2">
            {serviceTimes.map((time) => (
              <li
                key={time}
                className="flex items-center gap-2 font-dm-sans text-sm leading-5 text-[#4a4a4a]"
              >
                <IconClock size={15} stroke={1.5} className="shrink-0 text-[#9e7e43]/80" />
                <span>{time}</span>
              </li>
            ))}
          </ul>
        </div>

        <div className="mt-auto flex flex-wrap gap-2">
          {pagePath && (
            <Link
              to={pagePath}
              className="inline-flex w-fit items-center gap-1.5 rounded-lg bg-dc-primary-900 px-4 py-2 font-dm-sans text-sm font-semibold text-white transition duration-300 hover:bg-dc-primary-1000 group-hover:gap-2.5"
            >
              Visit chapter
              <IconArrowUpRight size={14} stroke={2} />
            </Link>
          )}
          {!/online|zoom/i.test(address) && (
            <a
              href={mapUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex w-fit items-center gap-1.5 rounded-lg border border-[#ebebeb] px-4 py-2 font-dm-sans text-sm font-semibold text-dc-primary-900 transition duration-300 hover:border-dc-primary-900/30 hover:bg-dc-primary-900/5 group-hover:gap-2.5"
            >
              Get directions
              <IconArrowUpRight size={14} stroke={2} />
            </a>
          )}
        </div>
      </div>
    </article>
  )
}

export default LandingLocationCard
